import {useContext} from 'react';
import CurrentAccountContext from './CurrentAccountContext';

const useCurrentAccount = () => useContext(CurrentAccountContext);

export default useCurrentAccount;
